'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _avatar = require('../avatar');

var _avatar2 = _interopRequireDefault(_avatar);

var _iconMute = require('../icons/icon-mute');

var _iconMute2 = _interopRequireDefault(_iconMute);

var _iconBlock = require('../icons/icon-block');

var _iconBlock2 = _interopRequireDefault(_iconBlock);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var displayName = 'ListItem';

var propTypes = {
  /** The ListItem's primary text */
  primaryText: _propTypes2.default.node.isRequired,
  /** The ListItem's secondary text */
  secondaryText: _propTypes2.default.node,
  /** A badge to display before the secondaryText. */
  textBadge: _propTypes2.default.node,
  /** Override the styles of the root element */
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the primaryText element */
  primaryTextStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the secondaryText element */
  secondaryTextStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Callback fired when the ListItem is clicked
   *
   * function(event: object) => void
   */
  onClick: _propTypes2.default.func,
  /** Add active styles to ListItem */
  active: _propTypes2.default.bool,
  /** Right-hand side placed button */
  rightButton: _propTypes2.default.node,
  /** The item's avatar, if a string is provided Avatar component is used */
  avatar: _propTypes2.default.node,
  /** Add a badge to the ListItem */
  badge: _propTypes2.default.node,
  /** Add muted styles to ListItem */
  muted: _propTypes2.default.bool,
  /** Add blocked styles to ListItem */
  blocked: _propTypes2.default.bool,
  color: _propTypes2.default.string.isRequired
};

var defaultProps = {
  style: {},
  secondaryText: '',
  textBadge: null,
  primaryTextStyle: {},
  secondaryTextStyle: {},
  onClick: null,
  active: false,
  rightButton: null,
  avatar: '',
  badge: null,
  muted: false,
  blocked: false
};

/** A list's item */
var ListItem = function ListItem(_ref) {
  var primaryText = _ref.primaryText,
      secondaryText = _ref.secondaryText,
      textBadge = _ref.textBadge,
      onClick = _ref.onClick,
      active = _ref.active,
      rightButton = _ref.rightButton,
      avatar = _ref.avatar,
      badge = _ref.badge,
      style = _ref.style,
      primaryTextStyle = _ref.primaryTextStyle,
      secondaryTextStyle = _ref.secondaryTextStyle,
      muted = _ref.muted,
      blocked = _ref.blocked,
      color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['primaryText', 'secondaryText', 'textBadge', 'onClick', 'active', 'rightButton', 'avatar', 'badge', 'style', 'primaryTextStyle', 'secondaryTextStyle', 'muted', 'blocked', 'color']);

  return _react2.default.createElement(
    'li',
    _extends({
      onClick: onClick,
      style: _getStyles2.default.root(color, active, style)
    }, custom),
    avatar ? _react2.default.createElement(
      'div',
      { style: _styles2.default.avatar },
      (0, _isString2.default)(avatar) ? _react2.default.createElement(_avatar2.default, { image: avatar }) : avatar,
      muted && !blocked ? _react2.default.createElement(
        'div',
        { style: _styles2.default.icon },
        _react2.default.createElement(_iconMute2.default, { color: _colors2.default.white })
      ) : null,
      blocked ? _react2.default.createElement(
        'div',
        { style: _styles2.default.icon },
        _react2.default.createElement(_iconBlock2.default, { color: _colors2.default.white })
      ) : null,
      badge ? _react2.default.createElement(
        'div',
        { style: _styles2.default.badge },
        badge
      ) : null
    ) : null,
    _react2.default.createElement(
      'div',
      { style: _getStyles2.default.textContainer(avatar, rightButton) },
      _react2.default.createElement(
        'h1',
        { style: _getStyles2.default.text(_styles2.default.primaryText, active, null, primaryTextStyle) },
        primaryText
      ),
      secondaryText || textBadge ? _react2.default.createElement(
        'h2',
        {
          style: _getStyles2.default.text(_styles2.default.secondaryText, active, textBadge, secondaryTextStyle)
        },
        textBadge,
        ' ',
        secondaryText
      ) : null
    ),
    rightButton ? _react2.default.createElement(
      'div',
      { style: _styles2.default.button },
      rightButton
    ) : null
  );
};

ListItem.displayName = displayName;
ListItem.propTypes = propTypes;
ListItem.defaultProps = defaultProps;

exports.default = ListItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/list-item/component.js
// module id = 894
// module chunks = 0